import { render, staticRenderFns } from "./MenuListTopFranchise.vue?vue&type=template&id=b7442b50&scoped=true&"
import script from "./MenuListTopFranchise.vue?vue&type=script&lang=js&"
export * from "./MenuListTopFranchise.vue?vue&type=script&lang=js&"
import style0 from "./MenuListTopFranchise.vue?vue&type=style&index=0&id=b7442b50&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7442b50",
  null
  
)

export default component.exports